import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class hrefLocation {
  urlHost = 'https://' + window.location.host;
}
